export default "__VITE_ASSET__BfjuZnZh__"